/**
 * Checks if value exists in an object and then returns the value if it exists or
 * the fallback default
 *
 * @param {Object} obj The object in which to check values
 * @param {Any} value The value to check if it exists in the object
 * @param {Any} fallback The value to fall back to
 * @param {String} message The error to emit if the value is missing
 * @returns {Any} The value or default
 */
export function validateObjectValue(obj, value, fallback = undefined, message = '') {
    if (!Object.values(obj).includes(value)) {
        value = fallback;
        if (message) {
            // eslint-disable-next-line no-console
            console.error(message);
        }
    }
    return value;
}

export const deepClone = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        const cloned = [];
        obj.forEach((item) => cloned.push(deepClone(item)));
        return cloned;
    }
    const cloned = {};
    Object.keys(obj).forEach((key) => {
        cloned[key] = deepClone(obj[key]);
    });
    return cloned;
};
